import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import WorkRow from './components/WorkRow';
import Footer from './components/Footer';
import { peintures, musiques, parfums } from './data/works';

function App() {
  const [scrollY, setScrollY] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      requestAnimationFrame(() => setScrollY(window.scrollY));
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Combine all works with their category for section IDs
  const allWorks = [
    ...peintures.map((w, i) => ({ ...w, category: 'peinture', isFirst: i === 0 })),
    ...musiques.map((w, i) => ({ ...w, category: 'musique', isFirst: i === 0 })),
    ...parfums.map((w, i) => ({ ...w, category: 'parfum', isFirst: i === 0 }))
  ];

  return (
    <div>
      <Header 
        scrollY={scrollY} 
        menuOpen={menuOpen} 
        setMenuOpen={setMenuOpen} 
      />
      
      <Hero scrollY={scrollY} />
      
      <main style={{ backgroundColor: '#fff' }}>
        <div style={{ width: '100%', borderTop: '1px solid #000' }}>
          {allWorks.map((work, idx) => (
            <WorkRow 
              key={idx}
              work={work}
              id={work.isFirst ? work.category : undefined}
              scrollY={scrollY}
              index={idx}
            />
          ))}
        </div>
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
